

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { locationHead } from "../../../../../config/constant";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import SearchText from '../../../../Shared/components/SearchText';

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, onView, handleOpen,
        loadMoreContent, loadMoreTask, search,
        onEdit, onDelete, roleManagement } = props;


    const address = (details) => {
        let address = details?.address || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={locationHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ width: getColumnWidth(locationHead, 0) }}>
                                                {
                                                    roleManagement !== '' && checkCRUDPermission('Location', 'view', 'Product') ?
                                                        <NavLink id={idNamingConversion('View_' + data.id, 'Location', 'Link')} style={{ width: getColumnWidth(locationHead, 0) }} to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.name || ''}</NavLink>
                                                        : <span style={{ width: getColumnWidth(locationHead, 0) }}>{data.name || '---'}</span>
                                                }
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(locationHead, 1) }}><span style={{ width: getColumnWidth(locationHead, 1) }}>{data?.default ? 'Yes' : 'No'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(locationHead, 2) }}><span style={{ width: getColumnWidth(locationHead, 1) }}>  <p>{address(data)}</p>
                                            <p style={{ marginTop: 10 }}>{address1(data)}</p></span></TableCell>
                                          
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Location', 'view', 'Product') &&
                                                        <NavLink id={idNamingConversion('View_' + data.id, 'Location', 'Icon')} to={"#"} onClick={() => onView(data, true, true)}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Location', 'edit', 'Product') &&
                                                        <NavLink id={idNamingConversion('Edit_' + data.id, 'Location', 'Icon')} to={"#"} onClick={() => onEdit(data, false, true)}>
                                                            <Image src={EditIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Location', 'deletable', 'Product') &&
                                                        <NavLink id={idNamingConversion('Delete_' + data.id, 'Location', 'Icon')} to={"#"} onClick={() => onDelete(data)} >
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                   
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                {
                                                    search !== '' ? <SearchText /> : <>
                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by creating your location'}</p>
                                                        <div className={classes.margin20t}>
                                                            <NavLink
                                                                style={{ display: "inline-block" }}
                                                                to={`#`}
                                                                onClick={() => handleOpen()}
                                                                className={clsx(classes.modalBtn)}>Create Location
                                                            </NavLink>
                                                        </div></>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}